import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import BranchDeptChatsContent from "./BranchDeptChatsContent";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import BranchDeptChatsActions from "./widget/BranchDeptChatsActions";
import { HomeContextProvider } from "../../../provider/home/HomeContextProvider";
import { BranchDeptChatsContextProvider } from "../../../provider/branch/branch_dept_chats/BranchDeptChatsContextProvider";

const BranchDeptChatsScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <HomeContextProvider>
      <BranchDeptChatsContextProvider>
        <Scaffold
          appBarTitle={AppTranslation.text("dept_chats")}
          appBarAction={<BranchDeptChatsActions />}
        >
          <MainBodyContainer>
            <BranchDeptChatsContent type={type} isModal={false} />
          </MainBodyContainer>
        </Scaffold>
      </BranchDeptChatsContextProvider>
    </HomeContextProvider>
  );
};

export default BranchDeptChatsScreen;
export const routeName: string = "/branch-dept-chats";
